import {CanDeactivateFn} from '@angular/router';
import {inject} from '@angular/core'
import {NavigationService} from "../../shared/data-access/navigation.service";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}

export const leaveActiveReportGuard: CanDeactivateFn<ComponentCanDeactivate> = (component) => {
  const navigationService = inject(NavigationService);

  if (navigationService.skipDeactivateGuard()) {
    return true
  }
  return component.canDeactivate ? component.canDeactivate() : window.confirm('Stillstand verwerfen?');
};
